import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

//Calendar
import CalendarReducer from "./calendar/reducer";

// Cantact
import ContactReducer from "./contact/reducer";

// Team
import TeamReducer from "./team/reducer";

// Dashboard
import DashboardReducer from "./dashboard/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Calendar: CalendarReducer,
  Contacts: ContactReducer,
  Team: TeamReducer,
  Dashboard: DashboardReducer
});

export default rootReducer;